import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=078753dd&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=078753dd&scoped=true&lang=css&"
import style1 from "./AppMain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078753dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078753dd')) {
      api.createRecord('078753dd', component.options)
    } else {
      api.reload('078753dd', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=078753dd&scoped=true&", function () {
      api.rerender('078753dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/AppMain.vue"
export default component.exports